import { Description, Image, Title } from "@/ui";
import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import classes from "./styles.module.scss";

export const Benefits = ({ className, bgColor, textColor, title, titleColor, items }) => {
  return (
    <div className={clsx(className, textColor, bgColor, classes.benefits)}>
      <Container>
        <Title title={title} className={clsx(titleColor, "mb-4")} />
        <Row>
          {items.map((i, k) => (
            <Col key={k} xs={12} md={4} className="mb-4">
              <div className={classes.benefits__item}>
                <Image img={i.icon} size="50x50" alt="" />
                <div>
                  <Title title={i.title} tag="h3" className="h4" />
                  <Description description={i.text} />
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Benefits;
